const guaranteeWrapper = document.querySelector('.addToCart--secure');

function updateGuarantee() {

    const bundles = document.querySelectorAll('.kaching-bundles__bar');
    const activeBundle = document.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected');

    if (!activeBundle || !bundles.length) return;

    const days = activeBundle === bundles[0] ? 90 : 30;

    const guaranteeTitle = document.querySelector('.guarantee-title strong');

    if (guaranteeTitle) {
        guaranteeTitle.textContent = `${days} Days`;
    }

    if (guaranteeWrapper) {
        guaranteeWrapper.innerHTML = `
            <img src="https://cdn.shopify.com/s/files/1/0779/8459/6252/files/shield.png?v=1753865507" alt="Guarantee">
            <span>${days} Day Money-Back Guarantee</span>
        `;
    }

}

// Default state
const guaranteeTitle = document.querySelector('.guarantee-title strong');

if (guaranteeTitle) {
    guaranteeTitle.textContent = '90 Days';
}

if (guaranteeWrapper) {
    guaranteeWrapper.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0779/8459/6252/files/shield.png?v=1753865507" alt="Guarantee">
        <span>90 Day Money-Back Guarantee</span>
    `;
}

document.addEventListener('click', function (e) {

    if (!e.target.closest('.kaching-bundles__bar')) return;

    setTimeout(updateGuarantee, 100);

});